// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dialpad-box[data-v-3725a15a] {
  right: 80px !important;
  left: auto !important;
  top: 58px !important;
  position: fixed !important;
}
.dialpad[data-v-3725a15a] .contact-number .v-input__control .v-input__slot:after,
.dialpad[data-v-3725a15a] .contact-number .v-input__control .v-input__slot:before {
  opacity: 0 !important;
}
.dialpad[data-v-3725a15a],
.dialpad[data-v-3725a15a] .v-btn {
  font-size: 24px;
}
.dialpad-add-icon[data-v-3725a15a] {
  position: relative;
}
.dialpad-add-icon[data-v-3725a15a] .v-icon {
  position: absolute;
  bottom: -11px;
  left: 0px;
  right: 0px;
  font-size: 11px !important;
}
.call-counter[data-v-3725a15a] {
  font-size: 16px;
  transition: all 0.2s linear;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0;
  bottom: 0;
  transform: scale(0, 0);
  background-color: rgba(31, 31, 31, 0.9);
  opacity: 0;
  visibility: hidden;
}
.call-started .call-counter[data-v-3725a15a] {
  transform: scale(1, 1);
  opacity: 1;
  visibility: visible;
  z-index: 10;
}
.call-forward .dialpad[data-v-3725a15a] {
  left: 0px;
  opacity: 1;
}
.show-dialpad .dialpad[data-v-3725a15a] {
  left: 0px;
  opacity: 1;
}
.call-counter .number[data-v-3725a15a] {
  font-size: 20px;
}
.call-counter > .flex[data-v-3725a15a]:nth-child(2) {
  display: flex;
  min-height: 63%;
}
.call-counter .label-counter[data-v-3725a15a] {
  margin: auto;
}
.n-arrow[data-v-3725a15a] {
  transition: all 0.3s linear;
  border-color: transparent;
  border-bottom-color: #fff;
  border-style: dashed dashed solid;
  border-width: 0 8.5px 8.5px;
  position: absolute;
  left: 13px;
  top: 50px;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
}
.v-menu__activator.v-menu__activator--active .n-arrow[data-v-3725a15a] {
  top: 31px;
  z-index: 1;
  opacity: 1;
  visibility: visible;
}
.v-list__tile__sub-title[data-v-3725a15a] {
  font-size: 12px;
}
.offQueue .line-arrow[data-v-3725a15a] {
  position: absolute;
  height: 3px;
  width: 34px;
  transform: rotate(45deg);
  top: 13px;
}
.internal-phone-number.twilio-phonenumber[data-v-3725a15a] {
  padding-left: 0px !important;
}
.internal-phone-number.twilio-phonenumber[data-v-3725a15a] .selectedCountry {
  max-width: 50px;
  display: inline-block;
  position: static;
  padding-left: 8px !important;
  vertical-align: top;
}
.internal-phone-number.twilio-phonenumber[data-v-3725a15a] .selectedCountry .input-group__selections {
  display: inline-block;
  position: relative;
  top: 5px;
}
.internal-phone-number.twilio-phonenumber[data-v-3725a15a] .contact-number .v-text-field label {
  top: 5px !important;
  left: 2px;
  font-size: 15px;
}
.internal-phone-number.twilio-phonenumber[data-v-3725a15a] .contact-number .v-text-field {
  padding-right: 30px;
}
.internal-phone-number[data-v-3725a15a] .validation {
  right: 27px !important;
  top: 6px !important;
}
.internal-phone-number.twilio-phonenumber[data-v-3725a15a] .backspace-icon {
  display: block;
  position: absolute;
  right: 0px;
  top: 10px;
}
.internal-phone-number.twilio-phonenumber[data-v-3725a15a] .contact-number {
  position: inherit;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
